import React, { Component } from "react";

import Registry from "./Utils/Registry";

import {
    IsLogged,
    SignOut,
    HandleRedirectURIResponse,
    GetAuthorizationHeader
} from "@TaankYou/auth";
import {notify} from "./Utils/Observers";
import {USER_LOGGED_IN_EVENT} from "./Utils/Events";
import { api as serviceApi } from "@TaankYou/services";


export class TokenHandler extends Component{
    constructor(props){
        super(props);
        this.api = Registry.registered("api");
        if(!this.api)
            console.error("Tankyou must be initialized");
        this.state = { error: false };
    }

    componentDidMount(){
        HandleRedirectURIResponse()
            .then(async () => {
                if(!IsLogged())
                    this.setState({error: true});
                else{
                    this.api.getUser()
                        .then(res => {
                            if (res && res.business_id) {
                                notify(USER_LOGGED_IN_EVENT, res);
                                this.api.get('/business/' + res.business_id)
                                    .then(results => {
                                        Registry.register("business-logo", this.api.url + "/files/" + results.business.logo);
                                        serviceApi.AddHeader("Authorization", GetAuthorizationHeader());
                                    });
                                return res
                            }
                            else {
                                const { protocol, host } = window.location;
                                SignOut(`${protocol}//${host}`);
                            }
                        })
                        .then(res => this.props.onSuccess(res))
                        .catch(e => {
                            console.error(e);
                            this.setState({error: true})
                        });
                }
            })
            .catch(e => {
                console.error(e);
                this.setState({error: true})
            });
    }

    retry = () => {
        const { protocol, host } = window.location;
        SignOut(`${protocol}//${host}`);
    }

    render(){
        const { error } = this.state;

        if(error){
            return <div className="loading-overlay">
                <i className="fa fa-exclamation-circle fa-3x fa-fw"></i><br /><br />
                Un erreur est survenue ...
                <br /><br />
                <div className="pink-hover underline pointer" onClick={this.retry}>R&eacute;essayer</div>
            </div>
        }

        return <div className="loading-overlay">
            <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i><br /><br />
            Connexion ...
        </div>;
    }
}


TokenHandler.defaultProps = {
    onFailed: error => {},
    onSuccess: () => {}
};



// WEBPACK FOOTER //
// ./src/auth.js